import { CheckBoxWidget, TextFieldWidget } from '@tableau/widgets';
import React = require('react');
import { Messages } from '~src/codegen/Localize';
import { interpolateString } from '~src/common/utilities/StringInterpolation';
import { cssClass } from '~src/style';

import { IResourceGovernanceSettingsKey } from '../types/ResourceGovernance';
const cssClassPrefix = 'resource-governance-limits-row';
const topLeftPadClass = cssClass(cssClassPrefix, 'left-pad', {
  paddingLeft: 20,
  paddingTop: 10,
  verticalAlign: 'middle',
});
const defaultValueStyle = cssClass(cssClassPrefix, 'default', {
  fontSize: 14,
  textAlign: 'center',
  verticalAlign: 'middle',
});

interface LimitsRowState {
  isChecked: boolean;
}

export interface ConcurrentJobLimitRowProps {
  limitType: string;
  value: number;
  originalValue: number;
  description: string;
  update: (value: string) => void;
  testId: IResourceGovernanceSettingsKey;
  defaultValue?: number;
  hasDefault?: boolean;
}

export function rowShouldAlert(value: number | undefined, original: number | undefined): boolean {
  // undefined cases handled automatically by "<";
  // undefined < [anything] === false, [anything] < undefined === false
  return value < original;
}
export class ResourceGovernanceLimitsRow extends React.Component<ConcurrentJobLimitRowProps, LimitsRowState> {
  public constructor(props: ConcurrentJobLimitRowProps){
    super(props);
    this.state = {
      isChecked: props.value === undefined
    };
  }

  public render() {
    const description = interpolateString(this.props.description, {
      LIMIT_TYPE: () => <b key={`bold-text-${this.props.limitType}`}>{this.props.limitType}</b>
    });

    const alertStyle = {
      // http://design/guidelines/style/color Warning Global
      borderColor: '#feca63',
    };

    const handleCheckboxChange = (checked: boolean) => {
      this.setState({ isChecked: checked });
      if (checked) {
        this.props.update(undefined);
      } else {
        const valueToUpdateWith = this.props.originalValue !== undefined
          ? `${this.props.originalValue}`
          : '';
        this.props.update(valueToUpdateWith);
      }
    };

    const inputStyle = rowShouldAlert(this.props.value, this.props.originalValue) ? alertStyle : {};
    const onlyPositiveNums = (value: string) => !value || /^\d+\.?\d*$/.test(value);
    const inputValid = this.props.value !== undefined && !isNaN(this.props.value) && isFinite(this.props.value);
    const inputValue = inputValid ? this.props.value : '';
    const defaultValue = this.props.hasDefault
      ? this.props.defaultValue !== undefined
        ? this.props.defaultValue
        : Messages.resourceGovernanceNoLimitValue()
      : undefined;
    return <tr key={`row-${this.props.limitType}`}>
      <td className={topLeftPadClass}>{description}</td>
      <td style={{ paddingLeft: 30, minWidth: 50 }}>
        <CheckBoxWidget
          testId={`no-limit-checkbox-${this.props.testId}`}
          checked={this.state.isChecked}
          handleChange={handleCheckboxChange}
        />
      </td>
      <td className={topLeftPadClass}>
        <TextFieldWidget
          label={''}
          testId={`input-${this.props.testId}`}
          value={inputValue}
          placeholder={this.state.isChecked ? Messages.resourceGovernanceNoLimitValue() : ''}
          disabled={this.state.isChecked}
          onChange={event => onlyPositiveNums(event.target.value) && this.props.update(event.target.value)}
          style={inputStyle}
        />
      </td>
      {defaultValue && <td className={defaultValueStyle}><b>{defaultValue}</b></td>}
    </tr>;
  }
}